import { render, staticRenderFns } from "./print-estudiante-template.vue?vue&type=template&id=285f95d0&scoped=true&"
import script from "./print-estudiante-template.vue?vue&type=script&lang=js&"
export * from "./print-estudiante-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f95d0",
  null
  
)

export default component.exports